/**
 * AnimatedFlowOrange — Custom edge with orange base line + animated white dashes
 * Used for cooling system → production lines connections
 */
import { type EdgeProps, getBezierPath } from '@xyflow/react';

export function AnimatedFlowOrange(props: EdgeProps) {
    const [edgePath] = getBezierPath(props);

    return (
        <g>
            {/* Ligne orange solide fixe */}
            <path
                d={edgePath}
                fill="none"
                stroke="#FF9800"
                strokeWidth={3}
            />
            {/* Ligne blanche pointillée animée par-dessus */}
            <path
                d={edgePath}
                fill="none"
                stroke="white"
                strokeWidth={2}
                strokeDasharray="8 12"
                style={{
                    animation: 'dash-flow 1.5s linear infinite',
                }}
            />
        </g>
    );
}
